const ID = 'kiosk-radio-button';
export interface KioskRadioButtonProps {
    id?: string;
    disabled?: boolean;
    text: string | React.ReactNode;
    subtext?: string | React.ReactNode;
    onClick: () => void;
    selected: boolean;
}

const KioskRadioButton = (props: KioskRadioButtonProps) => {
    const { disabled, text, subtext, onClick, selected } = props;

    return (
        <button
            id={(props.id ? props.id + '-' : '') + ID}
            onClick={onClick}
            disabled={disabled}
            className={`bg-background-surface disabled:bg-background-default ${selected ? 'border-brand-primary' : 'border-border-default'} inline-flex items-center justify-start gap-4 self-stretch rounded-xl border px-4 py-3`}>
            <div
                data-variant='Checked'
                className={`h-4 w-4 ${disabled ? 'bg-background-default' : 'bg-background-surface'} border-border-default flex items-center justify-center rounded-full border`}>
                <div className={`size-2.5 rounded-full ${selected ? 'bg-brand-primary' : ''}`} />
            </div>

            <div className='inline-flex flex-1 flex-col items-start justify-center gap-0.5'>
                <div
                    className={`justify-start ${disabled ? 'text-brand-disabled' : 'text-foreground-default'} text-base ${subtext ? 'font-semibold' : 'font-medium'}`}>
                    {text}
                </div>
                {subtext && <div className={`justify-start ${disabled ? 'text-brand-disabled' : 'text-brand-muted'} text-sm font-medium`}>{subtext}</div>}
            </div>
        </button>
    );
};

export default KioskRadioButton;
